import React from 'react';
import '../../../styles/assideMenu.scss';
import {BiArrowToLeft} from 'react-icons/bi';
import {IoIosCloseCircleOutline} from 'react-icons/io';
import AsideMenuNav from './AsideMenuNav';
import {Link} from 'react-router-dom';
import {routes} from '../../../constants/routes';

const AsideMenuWrapBurger = ({item, eqv, setEqv, isOpenAside, setIsOpenAside, overview}) => {
  return (
    <div className={!isOpenAside ? `asside_menu_wrap_for-burger` : ''}>
      <div className="asside_menu_wrap">
        <div className="asside_menu_wrap_btn_back_wrap">
          <Link to={routes.chooseServer}>
            <BiArrowToLeft />
          </Link>
          <IoIosCloseCircleOutline
            className="close_burger"
            onClick={() => setIsOpenAside((state) => !state)}
          />
        </div>
        <div className="asside_menu_server_name_wrap">
          <div className={`server_content_img ${item?.color} img_asside_menu`}>
            <img src={overview?.avatar} alt="" />
            <div
              className={`info_pay_server ${item?.pay === 'silver' ? 'silver' : ''} ${
                item?.pay === 'gold' ? 'gold' : ''
              } ${item?.pay === 'free' ? 'free' : ''}`}>
              <img src="/img/server/infopay.svg" alt="" />
            </div>
          </div>
          <div className="asside_menu_server_info_wrap">
            <div className="server_content_name">{overview?.guild_name}</div>
            <div className="server_content_folower">
              <img src="/img/server/Followers.svg" alt="" />
              {overview?.memberCount}
            </div>
            {/* <div className='server__info-owner'>{item?.ownerInfo}</div> */}
          </div>
        </div>
        <AsideMenuNav eqv={eqv} setEqv={setEqv} item={item} setIsOpenAside={setIsOpenAside} />
      </div>
    </div>
  );
};

export default AsideMenuWrapBurger;
